import { setSearchTerm } from '../State/searchTerm'

export default (value) => (dispatch) => {

  dispatch(setSearchTerm(value))
    
}
